import cn from 'classnames';
import styles from './toggleButtonGroup.module.scss';

export interface IProps {
  /** Icon element to render */
  children: React.ReactNode,
  /** Additional CSS class names */
  className?: string,
}

const ToggleButtonGroupIcon = ({ children, className }: IProps): React.ReactElement => (
  <span className={ cn(styles.iconWrp, className) }>
    { children }
  </span>
);

export default ToggleButtonGroupIcon;
